import * as React from "react";
import { useAcceptInvite } from "./useAcceptInvite";
import { Button, Input, Spinner } from "@nextui-org/react";
import { AsButton, AsInput } from "app/subframe";
import { Loading } from "app/components/loading/loading";

export interface AcceptInviteProps {}

export const AcceptInvite: React.FC<AcceptInviteProps> = ({}) => {
  const { user, isLoading, isTokenValid, onSubmit } = useAcceptInvite();

  if (isLoading) {
    return (
      <div className="w-screen h-screen flex flex-col gap-4 items-center justify-center">
        <Loading label="Validating invite" type="dark" />
      </div>
    );
  }

  if (!isTokenValid) {
    return (
      <div className="w-screen h-screen flex flex-col gap-4 items-center justify-center">
        <h1 className="text-lg font-semibold">
          Your invite doesn't seem right
        </h1>
        <p>
          Please check the link again or contact the sender for a new invite
          link
        </p>
      </div>
    );
  }

  return (
    <div className="w-screen h-screen flex flex-col gap-4 items-center justify-center">
      <form
        className="flex flex-col gap-4 w-[600px] border-zinc-100 p-8 rounded-sm"
        onSubmit={onSubmit}
      >
        <div className="flex flex-col gap-4 mb-8 items-center">
          <h1 className="font-semibold text-lg">Welcome {user.name}</h1>
          <div className="flex flex-col gap-1 items-center">
            <p className="text-sm text-zinc-500">
              You've been invited by{" "}
              <span className="text-body-bold font-body-bold text-neutral-900">
                {user.account.name}
              </span>
            </p>
            <p className="text-sm text-zinc-500">
              Please enter your password below to complete sign up process
            </p>
          </div>
        </div>
        <AsInput
          label="Name"
          name="name"
          className="!bg-transparent border-none hover:border-none"
          placeholder="Enter name"
          value={user?.name}
          textPosition="left"
          disabled
        />
        <AsInput
          label="Email"
          name="email"
          type="email"
          className="!bg-transparent border-none hover:border-none"
          placeholder="Enter email"
          value={user?.email}
          disabled
          textPosition="left"
        />
        <AsInput
          label="Password"
          name="password"
          required
          placeholder="Enter password"
          // validate={(value) =>
          //   value.length < 8 ? "Password is too short" : ""
          // }
          // description="Password must be at least 8 characters long"
          textPosition="left"
        />
        <AsInput
          label="Confirm Password"
          name="passwordConfirmation"
          required
          placeholder="Re-enter password above to confirm"
          // validate={(value) =>
          //   value.length < 8 ? "Password is too short" : ""
          // }
          // description="Password must be at least 8 characters long"
          textPosition="left"
        />
        <AsButton size="md" type="submit" text="Sign up" />
      </form>
    </div>
  );
};
